import { combineReducers } from "@reduxjs/toolkit";
import oktaReducer from "./slices/oktaAuth/oktaAuth.slice";
import paginationReducer from "./slices/pagination/pagination.slice";
import packageSelectorReducer from "./slices/packageSelector/package-selector.slice";
import searchReducer from "./slices/search/search.slice";
import ApiSlice from "./slices/api";

const rootReducer = combineReducers({
  oktaState: oktaReducer,
  pagination: paginationReducer,
  packageSelector: packageSelectorReducer,
  search: searchReducer,
  [ApiSlice.reducerPath]: ApiSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
